import { render, staticRenderFns } from "./Descargar.vue?vue&type=template&id=58607ec4&scoped=true&"
import script from "./Descargar.vue?vue&type=script&lang=ts&"
export * from "./Descargar.vue?vue&type=script&lang=ts&"
import style0 from "./Descargar.vue?vue&type=style&index=0&id=58607ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58607ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('58607ec4', component.options)
    } else {
      api.reload('58607ec4', component.options)
    }
    module.hot.accept("./Descargar.vue?vue&type=template&id=58607ec4&scoped=true&", function () {
      api.rerender('58607ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/partes/Descargar.vue"
export default component.exports